var getAmountInDispute = function (userAnswers) {
    var userAnswerWithAmountInDispute = userAnswers.find(function (userAnswer) { return userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.isEligibleForPartialAmount; });
    if ((userAnswerWithAmountInDispute === null || userAnswerWithAmountInDispute === void 0 ? void 0 : userAnswerWithAmountInDispute.answers.length) > 1) {
        return userAnswerWithAmountInDispute === null || userAnswerWithAmountInDispute === void 0 ? void 0 : userAnswerWithAmountInDispute.answers[1];
    }
    if ((userAnswerWithAmountInDispute === null || userAnswerWithAmountInDispute === void 0 ? void 0 : userAnswerWithAmountInDispute.answers.length) === 1) {
        return userAnswerWithAmountInDispute === null || userAnswerWithAmountInDispute === void 0 ? void 0 : userAnswerWithAmountInDispute.answers[0];
    }
    return null;
};
export default getAmountInDispute;
//# sourceMappingURL=getAmountInDispute.js.map